import { FieldPath, UseFormReturn } from 'react-hook-form/dist/types';
import { FieldValues } from 'react-hook-form/dist/types/fields';

import { ApiError } from '@api/client/errors';

export const handleFormError = <T extends FieldValues>(
    { setError }: UseFormReturn<T>,
    error: unknown,
) => {
    if (!(error instanceof ApiError)) return;
    const invalidFirstFieldError = error.getInvalidFields<FieldPath<T>>();
    if (invalidFirstFieldError.length > 0) {
        invalidFirstFieldError.forEach(({ name, message }, index) => {
            setError(name, { message }, { shouldFocus: index === 0 });
        });
    }
};
